var map = {
	"./black/blue.svg": 795,
	"./black/btc.svg": 796,
	"./black/etc.svg": 797,
	"./black/eth.svg": 798,
	"./black/llm.svg": 799,
	"./black/ltc.svg": 800,
	"./black/rsd.svg": 801,
	"./black/safex.svg": 802,
	"./black/sft.svg": 803,
	"./black/sfx.svg": 804,
	"./black/wsfx.svg": 805,
	"./black/xmr.svg": 806,
	"./color/blue.svg": 807,
	"./color/btc.svg": 808,
	"./color/etc.svg": 809,
	"./color/eth.svg": 810,
	"./color/llm.svg": 811,
	"./color/ltc.svg": 812,
	"./color/rsd.svg": 813,
	"./color/safex.svg": 814,
	"./color/sft.svg": 815,
	"./color/sfx.svg": 816,
	"./color/wsfx.svg": 817,
	"./color/xmr.svg": 818,
	"./icon/blue.svg": 819,
	"./icon/btc.svg": 820,
	"./icon/etc.svg": 821,
	"./icon/eth.svg": 822,
	"./icon/llm.svg": 823,
	"./icon/ltc.svg": 824,
	"./icon/rsd.svg": 825,
	"./icon/safex.svg": 826,
	"./icon/sft.svg": 827,
	"./icon/sfx.svg": 828,
	"./icon/wsfx.svg": 829,
	"./icon/xmr.svg": 830,
	"./white/blue.svg": 831,
	"./white/btc.svg": 832,
	"./white/etc.svg": 833,
	"./white/eth.svg": 834,
	"./white/llm.svg": 835,
	"./white/ltc.svg": 836,
	"./white/rsd.svg": 837,
	"./white/safex.svg": 838,
	"./white/sft.svg": 839,
	"./white/sfx.svg": 840,
	"./white/wsfx.svg": 841,
	"./white/xmr.svg": 842
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 794;